import React from 'react';

const FinancialYearDropdown = ({ selectedFinancialYear, onChange }) => {
  // Calculate the current year
  const currentYear = new Date().getFullYear();
  
  // Generate years from 2015 to the current year
  const financialYears = Array.from({ length: currentYear - 2015 + 1 }, (v, i) => ({
    value: (2015 + i).toString(),
    label: (2015 + i).toString(),
  })).reverse(); // Reverse the array to show years in descending order
  // console.log('calling')

  return (
    <div>
      <label htmlFor="financial-year"
        className="block text-gray-700 text-sm font-semibold  mb-2">
        Financial Year
      </label>
      <select
        id="financial-year"
        name="financialYear"
        value={selectedFinancialYear}
        onChange={onChange}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
      >
        <option value="">All</option>
        {financialYears.map((year) => (
          <option key={year.value} value={year.value}>
            {year.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default FinancialYearDropdown;
